import { fetchCurrentUser } from '../../ducks/user.duck';
import { addRulebookPromptsApi, deletePromptByIdApi, deleteRulebookApi, deleteRuleBookFile, fetchSpaceListApiV2, getAllRulebooks, getRulebookPromptsApi, getSpecificUserGPTS, addNewRulebook, updateExistingRulebook, retryRulebookIndexingApi, getRulebookIndexingStatusApi } from '../../util/api';
import { group_rulebook, rulebookTypes } from '../../util/types';
import { parse } from '../../util/urlHelpers';

const GROUP_RULEBOOKS_PER_PAGE = 10;

// ================ Action types ================ //

export const FETCH_SPACE_LIST_REQUEST = 'app/AdminPanelSupabasePage/FETCH_SPACE_LIST_REQUEST';
export const FETCH_SPACE_LIST_SUCCESS = 'app/AdminPanelSupabasePage/FETCH_SPACE_LIST_SUCCESS';
export const FETCH_SPACE_LIST_ERROR = 'app/AdminPanelSupabasePage/FETCH_SPACE_LIST_ERROR';
export const OPEN_EDIT_MODAL = 'app/AdminPanelSupabasePage/OPEN_EDIT_MODAL';
export const CLOSE_EDIT_MODAL = 'app/AdminPanelSupabasePage/CLOSE_EDIT_MODAL';
export const FETCH_SPACE_DETAILS_REQUEST = 'app/AdminPanelSupabasePage/FETCH_SPACE_DETAILS_REQUEST';
export const FETCH_SPACE_DETAILS_SUCCESS = 'app/AdminPanelSupabasePage/FETCH_SPACE_DETAILS_SUCCESS';
export const FETCH_SPACE_DETAILS_ERROR = 'app/AdminPanelSupabasePage/FETCH_SPACE_DETAILS_ERROR';
export const UPLOAD_DOCUMENT_REQUEST = 'app/AdminPanelSupabasePage/UPLOAD_DOCUMENT_REQUEST';
export const UPLOAD_DOCUMENT_SUCCESS = 'app/AdminPanelSupabasePage/UPLOAD_DOCUMENT_SUCCESS';
export const UPLOAD_DOCUMENT_ERROR = 'app/AdminPanelSupabasePage/UPLOAD_DOCUMENT_ERROR';
export const RETRY_RULEBOOK_INDEXING_REQUEST = 'app/AdminPanelSupabasePage/RETRY_RULEBOOK_INDEXING_REQUEST';
export const RETRY_RULEBOOK_INDEXING_SUCCESS = 'app/AdminPanelSupabasePage/RETRY_RULEBOOK_INDEXING_SUCCESS';
export const RETRY_RULEBOOK_INDEXING_ERROR = 'app/AdminPanelSupabasePage/RETRY_RULEBOOK_INDEXING_ERROR';
export const RULEBOOK_INDEXING_STATUS_SUCCESS = 'app/AdminPanelSupabasePage/RULEBOOK_INDEXING_STATUS_SUCCESS';
export const RULEBOOK_INDEXING_STATUS_ERROR = 'app/AdminPanelSupabasePage/RULEBOOK_INDEXING_STATUS_ERROR';
export const REQUEST_SPECIFIC_RULEBOOK = 'app/AdminPanelSupabasePage/REQUEST_SPECIFIC_RULEBOOK';
export const SUCCESS_SPECIFIC_RULEBOOK = 'app/AdminPanelSupabasePage/SUCCESS_SPECIFIC_RULEBOOK';
export const ERROR_SPECIFIC_RULEBOOK = 'app/AdminPanelSupabasePage/ERROR_SPECIFIC_RULEBOOK';
export const REQUEST_DELETE_RULEBOOK = 'app/AdminPanelSupabasePage/REQUEST_DELETE_RULEBOOK';
export const SUCCESS_DELETE_RULEBOOK = 'app/AdminPanelSupabasePage/SUCCESS_DELETE_RULEBOOK';
export const ERROR_DELETE_RULEBOOK = 'app/AdminPanelSupabasePage/ERROR_DELETE_RULEBOOK';

export const REQUEST_GENERAL_RULEBOOK = 'app/AdminPanelSupabasePage/REQUEST_GENERAL_RULEBOOK';
export const SUCCESS_GENERAL_RULEBOOK = 'app/AdminPanelSupabasePage/SUCCESS_GENERAL_RULEBOOK';
export const ERROR_GENERAL_RULEBOOK = 'app/AdminPanelSupabasePage/ERROR_GENERAL_RULEBOOK';

export const REQUEST_PRIMARY_RULEBOOK = 'app/AdminPanelSupabasePage/REQUEST_PRIMARY_RULEBOOK';
export const SUCCESS_PRIMARY_RULEBOOK = 'app/AdminPanelSupabasePage/SUCCESS_PRIMARY_RULEBOOK';
export const ERROR_PRIMARY_RULEBOOK = 'app/AdminPanelSupabasePage/ERROR_PRIMARY_RULEBOOK';

export const REQUEST_ADD_PROMPTS = 'app/AdminPanelSupabasePage/REQUEST_ADD_PROMPTS';
export const SUCCESS_ADD_PROMPTS = 'app/AdminPanelSupabasePage/SUCCESS_ADD_PROMPTS';
export const ERROR_ADD_PROMPTS = 'app/AdminPanelSupabasePage/ERROR_ADD_PROMPTS';

export const REQUEST_GET_RULEBOOK_PROMPTS = 'app/AdminPanelSupabasePage/REQUEST_GET_RULEBOOK_PROMPTS';
export const SUCCESS_GET_RULEBOOK_PROMPTS = 'app/AdminPanelSupabasePage/SUCCESS_GET_RULEBOOK_PROMPTS';
export const ERROR_GET_RULEBOOK_PROMPTS = 'app/AdminPanelSupabasePage/ERROR_GET_RULEBOOK_PROMPTS';

export const REQUEST_DELETE_PROMPT = 'app/AdminPanelSupabasePage/REQUEST_DELETE_PROMPT';
export const SUCCESS_DELETE_PROMPT = 'app/AdminPanelSupabasePage/SUCCESS_DELETE_PROMPT';
export const ERROR_DELETE_PROMPT = 'app/AdminPanelSupabasePage/ERROR_DELETE_PROMPT';


// ================ Reducer ================ //

const initialState = {
  fetchInProgress: false,
  fetchSpaceListError: null,
  spaceList: [],
  isEditModalOpen: false,
  selectedSpaceId: null,
  selectedSpaceDetails: null,
  fetchSpaceDetailsInProgress: false,
  fetchSpaceDetailsError: null,
  uploadDocumentInProgress: false,
  uploadDocumentError: null,
  retryRulebookIndexingInProgress: false,
  retryRulebookIndexingError: null,
  retryRulebookIndexingResult: null,
  rulebookIndexingStatus: null,
  rulebookIndexingStatusError: null,
  specificRulebookInprogress: false,
  specificRulebookData: null,
  errorSpecificRulebook: null,
  deleteRulebookInprogress: false,
  deleteRulebookData: null,
  errorDeleteRulebook: null,

  generalRulebookInprogress: false,
  generalRulebookData: null,
  errorGeneralRulebook: null,
  rulebookPagination: null,

  primaryRulebookInprogress: false,
  primaryRulebookData: null,
  errorPrimaryRulebook: null,

  addPromptsInProgress: false,
  addPrompts: null,
  addPromptsError: null,

  getRulebookPromptsInProgress: false,
  getRulebookPrompts: null,
  getRulebookPromptsError: null,

  deletePromptInProgress: false,
  deletePromptError: null,

};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_SPACE_LIST_REQUEST:
      return { ...state, fetchInProgress: true, fetchSpaceListError: null };
    case FETCH_SPACE_LIST_SUCCESS:
      return { ...state, fetchInProgress: false, spaceList: payload };
    case FETCH_SPACE_LIST_ERROR:
      return { ...state, fetchInProgress: false, fetchSpaceListError: payload };
    case OPEN_EDIT_MODAL:
      return {
        ...state,
        isEditModalOpen: true,
        selectedSpaceId: payload,
      };
    case CLOSE_EDIT_MODAL:
      return {
        ...state,
        isEditModalOpen: false,
        selectedSpaceId: null,
        selectedSpaceDetails: null,
        fetchSpaceDetailsError: null,
        uploadDocumentError: null,
      };
    case FETCH_SPACE_DETAILS_REQUEST:
      return {
        ...state,
        fetchSpaceDetailsInProgress: true,
        fetchSpaceDetailsError: null,
      };
    case FETCH_SPACE_DETAILS_SUCCESS:
      return {
        ...state,
        fetchSpaceDetailsInProgress: false,
        selectedSpaceDetails: payload,
      };
    case FETCH_SPACE_DETAILS_ERROR:
      return {
        ...state,
        fetchSpaceDetailsInProgress: false,
        fetchSpaceDetailsError: payload,
      };
    case UPLOAD_DOCUMENT_REQUEST:
      return {
        ...state,
        uploadDocumentInProgress: true,
        uploadDocumentError: null,
      };
    case UPLOAD_DOCUMENT_SUCCESS:
      return {
        ...state,
        uploadDocumentInProgress: false,
      };
    case UPLOAD_DOCUMENT_ERROR:
      return {
        ...state,
        uploadDocumentInProgress: false,
        uploadDocumentError: payload,
      };
    case RETRY_RULEBOOK_INDEXING_REQUEST:
      return {
        ...state,
        retryRulebookIndexingInProgress: true,
        retryRulebookIndexingError: null,
        retryRulebookIndexingResult: null,
      };
    case RETRY_RULEBOOK_INDEXING_SUCCESS:
      return {
        ...state,
        retryRulebookIndexingInProgress: false,
        retryRulebookIndexingResult: payload,
      };
    case RETRY_RULEBOOK_INDEXING_ERROR:
      return {
        ...state,
        retryRulebookIndexingInProgress: false,
        retryRulebookIndexingError: payload,
      };
    case RULEBOOK_INDEXING_STATUS_SUCCESS:
      return {
        ...state,
        rulebookIndexingStatus: payload,
        rulebookIndexingStatusError: null,
      };
    case RULEBOOK_INDEXING_STATUS_ERROR:
      return {
        ...state,
        rulebookIndexingStatusError: payload,
      };
    case REQUEST_SPECIFIC_RULEBOOK:
      return {
        ...state,
        specificRulebookInprogress: true,
        specificRulebookData: null,
        errorSpecificRulebook: null,
      }
    case SUCCESS_SPECIFIC_RULEBOOK:
      return {
        ...state,
        specificRulebookInprogress: false,
        specificRulebookData: payload.data,
      }
    case ERROR_SPECIFIC_RULEBOOK:
      return {
        ...state,
        specificRulebookInprogress: false,
        errorSpecificRulebook: payload.error,
      }
    case REQUEST_DELETE_RULEBOOK:
      return {
        ...state,
        deleteRulebookInprogress: true,
        deleteRulebookData: null,
        errorDeleteRulebook: null,
      }
    case SUCCESS_DELETE_RULEBOOK:
      return {
        ...state,
        deleteRulebookInprogress: false,
        deleteRulebookData: payload.data,
        specificRulebookData: null
      }
    case ERROR_DELETE_RULEBOOK:
      return {
        ...state,
        deleteRulebookInprogress: false,
        errorDeleteRulebook: payload.error,
      }

    case REQUEST_GENERAL_RULEBOOK:
      return {
        ...state,
        generalRulebookInprogress: true,
        generalRulebookData: null,
        errorGeneralRulebook: null,
      }
    case SUCCESS_GENERAL_RULEBOOK:
      return {
        ...state,
        generalRulebookInprogress: false,
        generalRulebookData: payload.data.gpts,
        rulebookPagination: payload.data.pagination,
        errorGeneralRulebook: null,
      }
    case ERROR_GENERAL_RULEBOOK:
      return {
        ...state,
        generalRulebookInprogress: false,
        errorGeneralRulebook: payload.error,
        generalRulebookData: null,
      }

    case REQUEST_PRIMARY_RULEBOOK:
      return {
        ...state,
        primaryRulebookInprogress: true,
        primaryRulebookData: null,
        errorPrimaryRulebook: null,
      }
    case SUCCESS_PRIMARY_RULEBOOK:
      return {
        ...state,
        primaryRulebookInprogress: false,
        primaryRulebookData: payload.data,
        errorPrimaryRulebook: null,
      }
    case ERROR_PRIMARY_RULEBOOK:
      return {
        ...state,
        primaryRulebookInprogress: false,
        errorPrimaryRulebook: payload.error,
        primaryRulebookData: null,
      }

    case REQUEST_ADD_PROMPTS:
      return {
        ...state,
        addPromptsInProgress: true,
        addPrompts: null,
        addPromptsError: null,
      }
    case SUCCESS_ADD_PROMPTS:
      return {
        ...state,
        addPromptsInProgress: false,
        addPrompts: payload,
        addPromptsError: null,
      }
    case ERROR_ADD_PROMPTS:
      return {
        ...state,
        addPromptsInProgress: false,
        addPrompts: null,
        addPromptsError: payload.error,
      }

    case REQUEST_GET_RULEBOOK_PROMPTS:
      return {
        ...state,
        getRulebookPromptsInProgress: true,
        getRulebookPrompts: null,
        getRulebookPromptsError: null,
      };

    case SUCCESS_GET_RULEBOOK_PROMPTS:
      return {
        ...state,
        getRulebookPromptsInProgress: false,
        getRulebookPrompts: payload.data,
        getRulebookPromptsError: null,
      };

    case ERROR_GET_RULEBOOK_PROMPTS:
      return {
        ...state,
        getRulebookPromptsInProgress: false,
        getRulebookPrompts: null,
        getRulebookPromptsError: payload.error,
      };

    case REQUEST_DELETE_PROMPT:
      return {
        ...state,
        deletePromptInProgress: true,
        deletePromptError: null,
      };

    case SUCCESS_DELETE_PROMPT:
      return {
        ...state,
        deletePromptInProgress: false,
        // Optionally filter out the deleted prompt from local list if needed
        getRulebookPrompts: {
          ...state?.getRulebookPrompts,
          prompts: state?.getRulebookPrompts?.prompts?.filter(p => p.id !== payload.id),
        },
        deletePromptError: null,
      };

    case ERROR_DELETE_PROMPT:
      return {
        ...state,
        deletePromptInProgress: false,
        deletePromptError: payload.error,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const requestSpecificRulebook = () => ({
  type: REQUEST_SPECIFIC_RULEBOOK
})

export const successSpecificRulebook = (data) => ({
  type: SUCCESS_SPECIFIC_RULEBOOK,
  payload: { data }
})

export const errorSpecificRulebook = (error) => ({
  type: ERROR_SPECIFIC_RULEBOOK,
  payload: { error }
})
export const requestDeleteRulebook = () => ({
  type: REQUEST_DELETE_RULEBOOK
})

export const successDeleteRulebook = (data) => ({
  type: SUCCESS_DELETE_RULEBOOK,
  payload: { data }
})

export const errorDeleteRulebook = (error) => ({
  type: ERROR_DELETE_RULEBOOK,
  payload: { error }
})

export const fetchSpaceListRequest = () => ({ type: FETCH_SPACE_LIST_REQUEST });
export const fetchSpaceListSuccess = spaces => ({
  type: FETCH_SPACE_LIST_SUCCESS,
  payload: spaces,
});
export const fetchSpaceListError = error => ({
  type: FETCH_SPACE_LIST_ERROR,
  payload: error,
});

export const openEditModal = spaceId => ({
  type: OPEN_EDIT_MODAL,
  payload: spaceId,
});

export const closeEditModal = () => ({
  type: CLOSE_EDIT_MODAL,
});

export const fetchSpaceDetailsRequest = () => ({
  type: FETCH_SPACE_DETAILS_REQUEST,
});

export const fetchSpaceDetailsSuccess = details => ({
  type: FETCH_SPACE_DETAILS_SUCCESS,
  payload: details,
});

export const fetchSpaceDetailsError = error => ({
  type: FETCH_SPACE_DETAILS_ERROR,
  payload: error,
});

export const uploadDocumentRequest = () => ({
  type: UPLOAD_DOCUMENT_REQUEST,
});

export const uploadDocumentSuccess = () => ({
  type: UPLOAD_DOCUMENT_SUCCESS,
});

export const uploadDocumentError = error => ({
  type: UPLOAD_DOCUMENT_ERROR,
  payload: error,
});

export const retryRulebookIndexingRequest = () => ({
  type: RETRY_RULEBOOK_INDEXING_REQUEST,
});

export const retryRulebookIndexingSuccess = data => ({
  type: RETRY_RULEBOOK_INDEXING_SUCCESS,
  payload: data,
});

export const retryRulebookIndexingError = error => ({
  type: RETRY_RULEBOOK_INDEXING_ERROR,
  payload: error,
});

export const rulebookIndexingStatusSuccess = data => ({
  type: RULEBOOK_INDEXING_STATUS_SUCCESS,
  payload: data,
});

export const rulebookIndexingStatusError = error => ({
  type: RULEBOOK_INDEXING_STATUS_ERROR,
  payload: error,
});

export const requestGeneralRulebook = () => ({
  type: REQUEST_GENERAL_RULEBOOK
});

export const successGeneralRulebook = (data) => ({
  type: SUCCESS_GENERAL_RULEBOOK,
  payload: { data }
});

export const errorGeneralRulebook = (error) => ({
  type: ERROR_GENERAL_RULEBOOK,
  payload: { error }
});

export const requestPrimaryRulebook = () => ({
  type: REQUEST_PRIMARY_RULEBOOK
});

export const successPrimaryRulebook = (data) => ({
  type: SUCCESS_PRIMARY_RULEBOOK,
  payload: { data }
});

export const errorPrimaryRulebook = (error) => ({
  type: ERROR_PRIMARY_RULEBOOK,
  payload: { error }
});

export const requestAddPrompts = () => ({
  type: REQUEST_ADD_PROMPTS
});

export const successAddPrompts = (data) => ({
  type: SUCCESS_ADD_PROMPTS,
  payload: { data }
});

export const errorAddPrompts = (error) => ({
  type: ERROR_ADD_PROMPTS,
  payload: { error }
});

export const requestGetRulebookPrompts = () => ({
  type: REQUEST_GET_RULEBOOK_PROMPTS
});

export const successGetRulebookPrompts = (data) => ({
  type: SUCCESS_GET_RULEBOOK_PROMPTS,
  payload: { data }
});

export const errorGetRulebookPrompts = (error) => ({
  type: ERROR_GET_RULEBOOK_PROMPTS,
  payload: { error }
});


export const requestDeletePrompt = () => ({
  type: REQUEST_DELETE_PROMPT
});

export const successDeletePrompt = (id) => ({
  type: SUCCESS_DELETE_PROMPT,
  payload: { id }
});

export const errorDeletePrompt = (error) => ({
  type: ERROR_DELETE_PROMPT,
  payload: { error }
});

// ================ Thunks ================ //

const getGroupRulebookIndexingStatus = rulebooks => {
  const statuses = rulebooks.map(rulebook => rulebook?.upload_process);

  if (statuses.includes('failed')) {
    return 'failed';
  }
  if (statuses.some(status => status && status !== 'done')) {
    return 'indexing';
  }
  if (statuses.includes('done')) {
    return 'done';
  }
  return null;
};

const mergeRulebookStatusIntoSpaces = (spaceResponse, groupRulebooks = []) => {
  const records = Array.isArray(spaceResponse?.records) ? spaceResponse.records : [];
  const rulebooksByGroupId = groupRulebooks.reduce((acc, rulebook) => {
    if (!rulebook?.group_id) {
      return acc;
    }
    acc[rulebook.group_id] = acc[rulebook.group_id] || [];
    acc[rulebook.group_id].push(rulebook);
    return acc;
  }, {});

  return {
    ...spaceResponse,
    records: records.map(space => {
      const rulebooks = rulebooksByGroupId[space.id] || [];
      const firstRulebook = rulebooks[0] || {};
      return {
        ...space,
        rulebook_indexing_status: getGroupRulebookIndexingStatus(rulebooks),
        rulebook_id: firstRulebook.rulebook_id,
        rulebook_name: firstRulebook.rulebook_name,
      };
    }),
  };
};


export const fetchSpaceList = (params) => (dispatch, getState, sdk) => {
  const {
    page = 1,
    per_page = 10,
    sort,
    keyword = '',
    silent = false,
    includeRulebookStatuses = true,
  } = params;
  if (!silent) {
    dispatch(fetchSpaceListRequest());
  }
  return fetchSpaceListApiV2({ per_page, page, sort, keyword })
    .then(async response => {
      if (!includeRulebookStatuses) {
        dispatch(fetchSpaceListSuccess(response));
        return response;
      }

      const groupRulebooksResponse = await getSpecificUserGPTS({
        rulebook_type: group_rulebook,
        include_incomplete: true,
        page: 1,
        limit: 10000,
      });
      const responseWithStatuses = mergeRulebookStatusIntoSpaces(
        response,
        groupRulebooksResponse?.gpts || []
      );
      dispatch(fetchSpaceListSuccess(responseWithStatuses));
      return responseWithStatuses;
    })
    .catch(e => {
      console.log('e', e);
      if (!silent) {
        dispatch(fetchSpaceListError("Failed to fetch space list"));
      }
      throw e;
    });
};

export const pollGroupRulebookIndexingStatuses = () => async (dispatch, getState) => {
  const currentSpaceList = getState().AdminPanelSupabasePage.spaceList;
  const groupRulebooksResponse = await getSpecificUserGPTS({
    rulebook_type: group_rulebook,
    include_incomplete: true,
    page: 1,
    limit: 10000,
  });
  const responseWithStatuses = mergeRulebookStatusIntoSpaces(
    currentSpaceList,
    groupRulebooksResponse?.gpts || []
  );
  dispatch(fetchSpaceListSuccess(responseWithStatuses));
  return responseWithStatuses;
};

export const getGeneralGroupRulebook = (params) => async (dispatch, getState, sdk) => {
  try {
    const { silent = false, ...apiParams } = params || {};
    if (!silent) {
      dispatch(requestGeneralRulebook())
    }
    const response = await getSpecificUserGPTS({ ...apiParams })
    dispatch(successGeneralRulebook(response))
    return response?.gpts;
  } catch (error) {
    if (!params?.silent) {
      dispatch(errorGeneralRulebook(error))
    }
  }
};

export const getPrimaryRulebook = (params) => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestPrimaryRulebook())
    const response = await getSpecificUserGPTS({ ...params })
    dispatch(successPrimaryRulebook(response?.gpts))
    return response?.gpts;
  } catch (error) {
    dispatch(errorPrimaryRulebook(error))
  }
};

export const loadData = (params, search, config) => (dispatch, getState) => {
  const queryParams = parse(search);
  const { sort_by = 'created_at', sort_order = 'desc', page = 1, keywords } = queryParams || {};
  return Promise.all([dispatch(fetchCurrentUser({}))])
    .then(async response => {
      const currentUser = getState().user.currentUser;
      if (currentUser?.attributes?.profile?.privateData?.isSupabaseAdmin) {
        const requests = [];
        if (params?.tab === 'general') {
          requests.push(dispatch(getGeneralGroupRulebook({ rulebook_type: rulebookTypes, sort_by, sort_order, page, limit: 10, keywords, include_incomplete: true })));
        } else {
          requests.push(dispatch(fetchSpaceList({
            page,
            per_page: GROUP_RULEBOOKS_PER_PAGE,
            sort: sort_order,
            keyword: keywords || '',
          })));
        }
        await Promise.all(requests);
      }
      return response;
    })
    .catch(e => {
      throw e;
    });
};

export const fetchSpaceDetails = spaceId => (dispatch, getState, sdk) => {
  dispatch(fetchSpaceDetailsRequest());
  return fetchSpaceList(spaceId)
    .then(response => {
      dispatch(fetchSpaceDetailsSuccess(response.data));
      return response;
    })
    .catch(e => {
      dispatch(fetchSpaceDetailsError(e.message));
      throw e;
    });
};

export const addRulebookDocument = (formData, editRulebook) => async (dispatch, getState, sdk) => {
  try {
    dispatch(uploadDocumentRequest());

    const response = editRulebook 
      ? await updateExistingRulebook(formData)
      : await addNewRulebook(formData);

    dispatch(getSpecificGroupRulebook({ id: formData.get('group_id') }));
    dispatch(getGeneralGroupRulebook({ rulebook_type: rulebookTypes, sort_by: 'created_at', sort_order: 'asc', page: 1, limit: 10, include_incomplete: true }))
    dispatch(uploadDocumentSuccess());
    return response;
  } catch (error) {
    dispatch(uploadDocumentError(error));
    throw error;
  }
};

export const getRulebookIndexingStatus = params => async dispatch => {
  try {
    const response = await getRulebookIndexingStatusApi(params);
    dispatch(rulebookIndexingStatusSuccess(response));
    return response;
  } catch (error) {
    dispatch(rulebookIndexingStatusError(error));
    throw error;
  }
};

export const getSpecificGroupRulebook = (params) => async (dispatch, getState, sdk) => {
  try {
    const { id: group_id, silent = false } = params ?? {}
    if (!silent) {
      dispatch(requestSpecificRulebook())
    }
    const response = await getAllRulebooks({ group_id, include_incomplete: true })
    dispatch(successSpecificRulebook(response?.gpts))
    return response?.gpts
  } catch (error) {
    if (!params?.silent) {
      dispatch(errorSpecificRulebook(error))
    }
  }
}

export const deleteSpecificGroupRulebook = params => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestDeleteRulebook());
    const { group_id } = params ?? {};
    const response = await deleteRulebookApi({ group_id });
    dispatch(getGeneralGroupRulebook({ rulebook_type: rulebookTypes, sort_by: 'created_at', sort_order: 'asc', page: 1, limit: 10, include_incomplete: true }))
    dispatch(successDeleteRulebook(response));
    return response;
  } catch (error) {
    dispatch(errorDeleteRulebook(error));
  }
};

export const deleteSpecificGroupRulebookFile = params => async (dispatch, getState, sdk) => {
  try {
    const { file_id, id } = params ?? {};
    if(!file_id) return;
    dispatch(requestDeleteRulebook());
    const response = await deleteRuleBookFile({ file_id });
    dispatch(getGeneralGroupRulebook({ rulebook_type: rulebookTypes, sort_by: 'created_at', sort_order: 'asc', page: 1, limit: 10, include_incomplete: true }))
    dispatch(successDeleteRulebook(response));
    return response;
  } catch (error) {
    dispatch(errorDeleteRulebook(error));
  }
};

export const retryRulebookIndexing = params => async dispatch => {
  try {
    dispatch(retryRulebookIndexingRequest());
    const response = await retryRulebookIndexingApi(params);
    const {
      page = 1,
      per_page = GROUP_RULEBOOKS_PER_PAGE,
      keyword = '',
      sort = 'desc',
    } = params || {};
    dispatch(retryRulebookIndexingSuccess(response));
    dispatch(fetchSpaceList({ page, per_page, keyword, sort }));
    dispatch(getGeneralGroupRulebook({ rulebook_type: rulebookTypes, sort_by: 'created_at', sort_order: 'asc', page: 1, limit: 10, include_incomplete: true }));
    if (params?.group_id) {
      dispatch(getSpecificGroupRulebook({ id: params.group_id }));
    }
    return response;
  } catch (error) {
    dispatch(retryRulebookIndexingError(error));
    throw error;
  }
};

export const addRulebookPrompts = params => (dispatch, getState, sdk) => {
  try {
    dispatch(requestAddPrompts());
    return addRulebookPromptsApi({ ...params }).then((response) => {
      dispatch(successAddPrompts(response)) //group id
      dispatch(getRulebookPrompts({ group_id: params?.group_id, page: 1 }))
      return response;
    });
  } catch (error) {
    dispatch(errorAddPrompts(error));
  }
};

export const getRulebookPrompts = (params) => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestGetRulebookPrompts());
    const response = await getRulebookPromptsApi({ group_id: params?.group_id, page: params?.page });
    dispatch(successGetRulebookPrompts(response));
    return response;
  } catch (error) {
    console.error("Error fetching rulebook prompts:", error);
    dispatch(errorGetRulebookPrompts(error));
    throw error;
  }
};

export const deletePrompt = ({ id, group_id }) => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestDeletePrompt());
    const response = await deletePromptByIdApi({ id }); // expects { id }
    dispatch(successDeletePrompt(id));
    dispatch(getRulebookPrompts({ group_id, page: 1 }))
    return response;
  } catch (error) {
    console.error("Error deleting prompt:", error);
    dispatch(errorDeletePrompt(error));
    throw error;
  }
};
